import { PanelFormBase } from './panel-form-base';
import { SimpleOption } from 'tsui/lib/models/simple-option';
import { ReportPeriod } from './report-period';
import { RelatedToType } from '@shared/enums';
import { BehaviorSubject, Observable } from 'rxjs';
import { FieldDefType } from '@core/models';

export type ChartVisualizationTypes = 'bar' | 'funnel' | 'pie' | 'mixed';

export type AllowedTimeSeriesTypes = Extract<FieldDefType, 'percent' | 'money' | 'number'>;

export type ChartFieldOption = SimpleOption & { format: AllowedTimeSeriesTypes };

export interface ChartVisualizationConfigMeta {
  type: ChartVisualizationTypes;
  direction?: 'vertical' | 'horizontal';
  stacked?: boolean;
  reversed?: boolean;
  timeSeries?: boolean;
}

export interface ChartVisualizationConfigSeries {
  fieldId: number | string;
  name: string;
  color?: string;
  type?: 'column' | 'line';
  displayLabels?: boolean;
  format?: AllowedTimeSeriesTypes;
}

export interface ChartVisualizationConfig extends PanelFormBase {
  series: ChartVisualizationConfigSeries[];
  reportPeriod: ReportPeriod;
  related_to: RelatedToType;
  meta: ChartVisualizationConfigMeta;
}

export interface ChartDataSource {
  rows: {
    [fieldId: number]: {
      name: string;
      data: number[];
    };
  };
  categories: (string | number)[];
}

export interface ChartPanelBuilderDialogData {
  fieldOptions: BehaviorSubject<ChartFieldOption[]>;
  // on the consumer component, the source change should update fieldOption$
  relatedToChanged: BehaviorSubject<RelatedToType>;
  chartVisualizationConfig?: ChartVisualizationConfig;
  dataSource?: (chartVisualizationConfig: ChartVisualizationConfig) => Observable<ChartDataSource>;
}

export enum ChartFormFields {
  field = 'field',
  direction = 'direction',
  stacked = 'stacked',
  reversed = 'reversed',
  reportPeriod = 'reportPeriod',
  relatedTo = 'relatedTo',
}
